export function Logo({ className = '' }: { className?: string }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 32 32" className={`shrink-0 ${className}`}>
      <rect width="32" height="32" rx="7" className="fill-surface-raised" />
      <rect
        x="6"
        y="9"
        width="14"
        height="14"
        rx="3"
        fill="none"
        strokeWidth="2.4"
        className="stroke-accent"
      />
      <path d="M20 14.5l6-3.5v10l-6-3.5z" className="fill-accent" />
    </svg>
  );
}
